import { decamelizeKeys } from "humps";
import { merge, omit, pick } from "lodash";

export const decamelizeDesiredKeys = <T extends Record<string, any>>(
  object: T,
  keysToDecamelize: string[]
): T => merge(omit(object, keysToDecamelize), decamelizeKeys(pick(object, keysToDecamelize))) as T;
